import { createStore } from '@exodus/jotai';
const store = createStore();
export { createStore } from '@exodus/jotai';
export default store;
